import AuthService from '@/service/auth/AuthService'
import CommonUtil from '@/util/CommonUtil'
import store from '@/store'
import jwtDecode from 'jwt-decode'

const PLUGIN_KEY = store.state.env.sns.channeltalk.pluginKey
const GUEST_ID_NAME = store.state.env.sns.channeltalk.guestIdName

function loadScript() {
  var w = window
  if (w.ChannelIO) {
    return (window.console.error || window.console.log || function () { })('ChannelIO script included twice.')
  }
  // var d = window.document
  var ch = function () {
    ch.c(arguments)
  }
  ch.q = []
  ch.c = function (args) {
    ch.q.push(args)
  }
  w.ChannelIO = ch
  function l() {
    if (w.ChannelIOInitialized) {
      return
    }
    w.ChannelIOInitialized = true
    var s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js'
    s.charset = 'UTF-8'
    var x = document.getElementsByTagName('script')[0]
    x.parentNode.insertBefore(s, x)
  }
  if (document.readyState === 'complete') {
    l()
  } else if (window.attachEvent) {
    window.attachEvent('onload', l)
  } else {
    window.addEventListener('DOMContentLoaded', l, false)
    window.addEventListener('load', l, false)
  }
}

function boot() {
  let obj = {
    pluginKey: PLUGIN_KEY,
    mobileOpenUI: 'iframe' // newTab / iframe
  }
  obj.profile = {}

  if (AuthService.isSignin() === true) {
    let user = AuthService.getProfile()
    obj.memberId = user.uuid
    obj.profile = {}

    obj.profile.name = user.name
    obj.profile.mobileNumber = user.phone
    obj.profile.email = user.email
    obj.profile.userAdminUrl = `${store.state.env.adminURL}/users/customer/${jwtDecode(AuthService.getToken().access_token).user_id}/change/`
  } else {
    let uuid = localStorage.getItem(GUEST_ID_NAME)
    if (uuid == null) {
      uuid = CommonUtil.uuid()
      localStorage.setItem(GUEST_ID_NAME, uuid)
    }
    obj.memberId = uuid
  }
  window.ChannelIO('boot', obj)
}

function shutdown() {
  window.ChannelIO('shutdown')
}

loadScript()
// window.ChannelIO('onBoot', guest => {
//   console.log(guest)
// })

export default {
  boot, shutdown
}
